import React from 'react';
import { site } from '../data/site';
export function SiteFooter() {
  return <footer className="border-t border-line" data-id="element-214" data-mp="3r8j4x0jp58o8">
      <div className="mx-auto flex max-w-7xl flex-col gap-3 px-5 py-8 text-sm text-faint md:flex-row md:items-center md:justify-between md:px-8" data-id="element-215" data-mp="3r9kjvg3u2fb8">
        <p data-id="element-216" data-mp="3hig268mrwgcp">© 2026 {site.name}. Independent editorial content.</p>
        <p data-id="element-217" data-mp="3hi6beitwm55y">Company information is based on each provider’s publicly available materials at the time of writing.</p>
      </div>
    </footer>;
}